import KeyboardButton from "../KeyboardButton/KeyboardButton";

import styles from "./LanguageSwitchButton.module.scss";

interface Props {
  onClick: () => void;
}

export default function LanguageSwitchButton({ onClick }: Props) {
  return (
    <KeyboardButton
      dataQA="language-switch"
      type="icon"
      icon="language"
      value=""
      onClick={onClick}
      className={styles.languageSwitchKey}
    />
  );
}
